export default __webpack_public_path__ + "static/media/KZ.T.05.2255 black.17c660ec.svg";